import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const navigate = useNavigate();

  const faqs: {
    question: string;
    answer: string | string[];
    button?: { label: string; href: string; external?: boolean };
  }[] = [
    {
      question: 'Почему разработка занимает всего 7 дней? Не пострадает ли качество?',
      answer: 'Скорость — результат исключения лишних посредников и использования современного технологического стека. Пока в классических студиях менеджер передает ТЗ программисту, мы уже внедряем смыслы в код. Мы тратим 80% времени на маркетинговую стратегию и 20% на техническую реализацию, а не наоборот.'
    },
    {
      question: 'Будет ли мой сайт отображаться в Google и Яндексе?',
      answer: 'Да. Базовая SEO-оптимизация и настройка локального поиска (Local SEO) уже включены в архитектуру. Ваш сайт будет технически готов к индексации и продвижению с первой секунды запуска.'
    },
    {
      question: 'Нужно ли мне самому писать тексты?',
      answer: 'Нет. Как специалист по системному маркетингу и копирайтингу, мы берем смысловую упаковку на себя. Нам понадобится только вводная информация от вас (бриф), на основе которой мы сформируем профессиональный контент по «Лестнице Ханта».'
    },
    {
      question: 'Будет ли сайт удобно открываться на смартфонах?',
      answer: 'Да, это стандарт качества. Более 80% трафика сейчас идет с мобильных устройств, поэтому мы используем подход Мобильная верстка Mobile-First. Сайт будет летать и идеально подстраиваться под любой экран.'
    },
    {
      question: 'Что если мне не понравится дизайн?',
      answer: 'Мы работаем по шагам. На этапе проектирования архитектуры (День 2) мы утверждаем структуру и логику. Дизайн лишь подчеркивает смыслы, которые мы согласовали. Моя цель — не просто «красиво», а эффективно для вашего бизнеса.'
    },
    {
      question: 'Входит ли стоимость домена и хостинга в цену разработки?',
      answer: 'Оплата домена и хостинга производится вами отдельно на ваш аккаунт, чтобы вы были полноправным владельцем сайта. Я помогу вам всё зарегистрировать и настроить «под ключ».'
    },
    {
      question: 'Что делать, если после запуска мне потребуется изменить текст или заменить фото?',
      answer: [
        'Мы не оставим вас один на один с сайтом сразу после запуска. В течение первого месяца действует бесплатная поддержка, которая включает:',
        'Внесение правок (от 5 до 15 корректировок: замена текстов, картинок, контактов).',
        'Контроль корректности работы всех форм и SEO-настроек.'
      ]
    },
    {
      question: 'Предлагаете ли вы сопровождение сайта на постоянной основе?',
      answer: [
        'Да, для тех, кто ценит стабильность, у нас есть услуга «Ежемесячное сопровождение веб-сайта» за 3.000 руб. В неё входит:',
        'Поддержка SEO-оптимизации: следим, чтобы сайт не терял позиции в поиске.',
        'Технические правки: до 5 корректировок контента в месяц.',
        'Контент-маркетинг: 1 профессиональная SEO-статья в подарок ежемесячно для роста бесплатного трафика.'
      ],
      button: { label: 'Узнать подробнее', href: '/landing-page-support', external: false }
    },
    {
      question: 'Вы делаете аудит уже готовых сайтов?',
      answer: 'Да. Если у вас есть сайт, который не приносит заявок, вы можете заказать экспертный аудит. Мы найдем пробелы в конверсии и составим пошаговый план, как превратить ваш текущий ресурс в прибыльную систему.',
      button: { label: 'Узнать подробнее', href: '/audit-landing-page', external: false }
    },
    {
      question: 'Помогаете ли вы с привлечением клиентов после запуска сайта?',
      answer: [
        'Запуск сайта — это только начало. Мы предлагаем комплекс услуг по продвижению и аналитике:',
        'Настройка рекламы: приводим целевой трафик.',
        'Сквозная аналитика: настраиваем систему так, чтобы вы видели, какой рекламный рубль принес реальную продажу.',
        'Постоянная оптимизация: на основе данных аналитики мы докручиваем конверсию, чтобы стоимость заявки для вас снижалась.'
      ],
      button: { label: 'Узнать подробнее', href: '#landing-page-final-cta' }
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const scrollToForm = () => {
    const formElement = document.getElementById('landing-page-final-cta');
    if (formElement) {
      formElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  return (
    <section className="py-12 sm:py-20 bg-[#F8F9FA]">
      <div className="max-w-5xl mx-auto px-4 sm:px-6">
        {/* Header */}
        <div className="text-center mb-10 sm:mb-16">
          <div className="flex items-center justify-center w-16 h-16 sm:w-20 sm:h-20 bg-[#C5A880] rounded-full mb-6 sm:mb-8 mx-auto">
            <i className="ri-question-answer-line text-3xl sm:text-4xl text-white"></i>
          </div>
          <h2 className="text-2xl sm:text-4xl md:text-5xl font-bold text-[#1A2B4C] mb-4 sm:mb-6 font-['Playfair_Display']">
            Ответы на важные вопросы
          </h2>
        </div>

        {/* FAQ Accordion */}
        <div className="space-y-3 sm:space-y-4 mb-8 sm:mb-12">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl border border-[#C5A880]/20 overflow-hidden hover:shadow-lg transition-all duration-300"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-4 sm:px-8 py-4 sm:py-6 flex items-center justify-between text-left hover:bg-[#F8F9FA] transition-colors cursor-pointer"
              >
                <div className="flex items-start gap-3 flex-1">
                  <div className="flex-shrink-0 w-7 h-7 sm:w-8 sm:h-8 bg-[#C5A880] rounded-full flex items-center justify-center mt-0.5">
                    <i className="ri-question-line text-white text-sm sm:text-lg"></i>
                  </div>
                  <h3 className="text-sm sm:text-lg font-semibold text-[#1A2B4C] pr-2 sm:pr-4 font-['Montserrat']">
                    {faq.question}
                  </h3>
                </div>
                <i
                  className={`ri-arrow-down-s-line text-xl sm:text-2xl text-[#C5A880] transition-transform duration-300 flex-shrink-0 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>

              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-[500px]' : 'max-h-0'
                }`}
              >
                <div className="px-4 sm:px-8 pb-4 sm:pb-6 pl-10 sm:pl-20">
                  {Array.isArray(faq.answer) ? (
                    <div className="space-y-2">
                      {faq.answer.map((line, i) => (
                        <p key={i} className="text-sm sm:text-base text-gray-700 leading-relaxed font-['Montserrat'] text-justify">
                          {line}
                        </p>
                      ))}
                    </div>
                  ) : (
                    <p className="text-sm sm:text-base text-gray-700 leading-relaxed font-['Montserrat'] text-justify">
                      {faq.answer}
                    </p>
                  )}
                  {faq.button && (
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        if (faq.button?.external === false) {
                          navigate(faq.button.href);
                        } else {
                          const el = document.getElementById('landing-page-final-cta');
                          if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
                        }
                      }}
                      className="inline-flex items-center gap-2 mt-4 bg-[#C5A880] hover:bg-[#B39770] text-white px-5 py-2.5 rounded-full text-sm font-semibold transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer font-['Montserrat']"
                    >
                      {faq.button.label}
                      <i className="ri-arrow-right-line text-base"></i>
                    </button>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA Button */}
        <div className="text-center">
          <button
            onClick={scrollToForm}
            className="inline-flex items-center gap-2 sm:gap-3 bg-[#C5A880] hover:bg-[#B39770] text-white px-6 sm:px-10 py-4 sm:py-5 rounded-full text-sm sm:text-lg font-semibold transition-all duration-300 shadow-xl hover:shadow-2xl hover:scale-105 whitespace-nowrap cursor-pointer font-['Montserrat']"
          >
            <i className="ri-chat-3-line text-xl sm:text-2xl"></i>
            Задайте вопрос напрямую
            <i className="ri-arrow-right-line text-base sm:text-xl"></i>
          </button>
        </div>
      </div>
    </section>
  );
}